export default __webpack_public_path__ + "static/media/hall_of_fame_bar_1.83870b47.png";